import { render } from "./FilterLoyaltyPointType.vue?vue&type=template&id=6d4a1da2"
import script from "./FilterLoyaltyPointType.vue?vue&type=script&lang=js"
export * from "./FilterLoyaltyPointType.vue?vue&type=script&lang=js"
script.render = render

export default script